import { useLazyQuery } from '@apollo/client';
import { SEARCH_SPOT_REVIEWS } from '../../graphql/spots.queries';

export default function useSearchSpotReviews() {
    const [searchSpotReviews, { data, loading, error }] = useLazyQuery(SEARCH_SPOT_REVIEWS);
    return { searchSpotReviews, searchResults: data?.searchSpotReviews, loading, error };
}
